import { mapGetters } from 'vuex';
import globalTypes from '@/store/types/global';
import whiteLabelTypes from '@/store/types/whiteLabel';
import reservationTypes from '@/store/types/reservation';
import LCrypt from 'lcrypt';
const lcrypt = new LCrypt(process.env.VUE_APP_TOKEN);
export default {
  computed: {
    ...mapGetters({
      multiLanguage: [globalTypes.getters.multiLanguage],
      vendors: [globalTypes.getters.vendor],
      vendorId: [globalTypes.getters.vendorId],
      loader: [whiteLabelTypes.getters.loader],
      disabledOnLog: [whiteLabelTypes.getters.disabledOnLog],
      loadingGeneral: [globalTypes.getters.loadingGeneral]
    }),
    vendor () {
      return this.vendors.vendor;
    },
    design () {
      return this.vendors.desing;
    },
    params () {
      return this.vendors.params;
    },
    designEvent () {
      return this.vendors.designEvent;
    },
    timezone () {
      let timezone = 'America/Bogota';
      if ((this.vendor || {}).timezone) {
        timezone = this.vendor.timezone;
      }
      return timezone;
    },
    idUser () {
      return this.getUserId;
    },
    poll () {
      return this.getPoll;
    },
    getStateMobile () {
      return this.$store.state.isMobile;
    }
  },
  methods: {
    ...mapGetters({
      Blocked: [reservationTypes.getters.blocked]
    }),
    encrypt (value) {
      return lcrypt.encode(value);
    },
    decryptMx (value) {
      return lcrypt.decode(value);
    },
    subDomain () {
      if (this.groupUrlVendor != null) {
        return this.groupUrlVendor;
      } else {
        let subdomain = window.location.hostname.split('.')[0];
        if (subdomain === 'www') {
          subdomain = window.location.hostname.split('.')[1];
        }
        return (
          subdomain === 'localhost' ||
          subdomain === 'developers' ||
          subdomain === 'select' ||
          subdomain === '192'
        ) ? 'qr' : subdomain;
      }
    },
    chargueScript (url, async = false) {
      const recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', url);
      if (async) {
        recaptchaScript.setAttribute('async', 'async');
      }
      document.body.appendChild(recaptchaScript);
    },
    gradient () {
      if (this.params.multiMenuBtnDegrade === 1) {
        return 'linear-gradient(rgba(18, 18, 18, 0.5), rgba(18, 18, 18, 0.5)),';
      } else {
        return '';
      }
    },
    chargueAmp (url, type = 0) {
      let info;
      let data;
      switch (type) {
        case 0:
          info = document.createElement('script');
          info.setAttribute('src', url);
          info.setAttribute('async', 'async');
          info.setAttribute('custom-element', 'amp-analytics');
          break;
        case 1:
          info = document.createElement('amp-analytics');
          info.setAttribute('type', 'gtag');
          info.setAttribute('data-credentials', 'include');
          data = document.createElement('script');
          data.setAttribute('type', 'application/json');
          data.setAttribute('src', url);
          info.appendChild(data);
          break;
      }
      document.body.appendChild(info);
    },
    loadScriptDefault (integrationDefaults) {
      if (integrationDefaults && integrationDefaults.length > 0) {
        const facebook = integrationDefaults.find(int => int.type === 'facebookPixel');
        const google = integrationDefaults.find(int => int.type === 'googlePixel');
        if (facebook) {
          this.chargueScript(facebook.login);
        }
        if (google) {
          if (google.merchant !== null && google.merchant !== '') {
            this.chargueScript(
              'https://www.googletagmanager.com/gtag/js?id=' + google.merchant
            );
          }
          if (google.account !== null && parseInt(google.account) === 1) {
            this.chargueAmp(
              'https://cdn.ampproject.org/v0/amp-analytics-0.1.js',
              0
            );
            this.chargueAmp(
              google.amp,
              1
            );
          }
          this.chargueScript(google.login);
        }
      }
    },
    loadScript (integrations) {
      if (integrations && integrations.length > 0) {
        const facebook = integrations.find(int => int.type === 'facebookPixel');
        const google = integrations.find(int => int.type === 'googlePixel');
        if (facebook) {
          this.chargueScript(facebook.login);
        }
        if (google) {
          if (google.merchant !== null && google.merchant !== '') {
            this.chargueScript(
              'https://www.googletagmanager.com/gtag/js?id=' + google.merchant
            );
          }
          if (google.account !== null && google.account === 1) {
            this.chargueAmp(
              'https://cdn.ampproject.org/v0/amp-analytics-0.1.js',
              0
            );
            this.chargueAmp(
              google.amp,
              1
            );
          }
          this.chargueScript(google.login);
        }
      }
    }
  }
};
